import(/* webpackMode: "eager" */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/src/components/blocks/LegalContent.tsx");
